import SettingItem from '../../settingItem/SettingItem';
import AddGooglePingItem from '../../addGooglePingItem/AddGooglePingItem';
import {isMaster} from '../../../../functions/permission';
import MasterPermission from '../../../components/rolePermission/MasterPermission';

function HubMailingForm() {
    
    return (
        <>
            <SettingItem name={'tickchakIndex'}>
                {isMaster() && <SettingItem name={'promotionInTickchak'}/>}
            </SettingItem>
            <SettingItem name={'glatticketIndex'} >
                {isMaster() && <SettingItem name={'promotionInGlatticket'}/>}
            </SettingItem>
            <MasterPermission>
                <SettingItem name={'showInLive'} >
                    <SettingItem name={'promotionInLive'} />
                </SettingItem>
            </MasterPermission>

            <SettingItem name={'isIndexed'}>
                <AddGooglePingItem />
            </SettingItem>
            <SettingItem name={'hideFollow'}/>
        </>
    );
}

export default HubMailingForm;
